import React, {
    useState,
    useEffect,
    forwardRef,
    useImperativeHandle,
} from "react";
import "./notification.scss";

const Notification = forwardRef((props, ref) => {
    const [notifications, setNotifications] = useState([]);

    useImperativeHandle(ref, () => ({
        addNotification: (message, type = "success", duration = 5000) => {
            const id = Math.random().toString(36).substr(2, 9);
            setNotifications((prevNotifications) => [
                { id, message, type, duration },
                ...prevNotifications,
            ]);
        },
    }));

    const removeNotification = (id) => {
        setNotifications((prevNotifications) =>
            prevNotifications.filter((notification) => notification.id !== id)
        );
    };

    useEffect(() => {
        notifications.forEach((notification) => {
            const timer = setTimeout(() => {
                removeNotification(notification.id);
            }, notification.duration);
            return () => clearTimeout(timer);
        });
    }, [notifications]);

    return (
        <div className="notification-container">
            {notifications.map((notification) => (
                <div
                    key={notification.id}
                    className={`notification notification--${notification.type}`}
                >
                    <p className="notification__message">
                        {notification.message}
                    </p>
                </div>
            ))}
        </div>
    );
});

export default Notification;
